import React from "react";
import "./ActivityModal.css";

interface ActivityModalProps {
  isOpen: boolean;
  title: string;
  options: string[];
  selectedOption: string;
  onSelect: (option: string) => void;
  onClose: () => void;
  onUpdate: () => void;
  loading?: boolean;
}

const ActivityModal: React.FC<ActivityModalProps> = ({
  isOpen,
  title,
  options,
  selectedOption,
  onSelect,
  onClose,
  onUpdate,
  loading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="activity-modal-overlay">
      <div className="activity-modal-content">
        <h3>{title}</h3>

        <div className="activity-option-list">
          {options.map((opt, idx) => (
            <button
              key={idx}
              className={`activity-option-btn ${
                selectedOption === opt ? "selected" : ""
              }`}
              onClick={() => onSelect(opt)}
            >
              {opt}
            </button>
          ))}
        </div>

        <div className="activity-modal-actions">
          <button className="activity-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="activity-update-btn" onClick={onUpdate}>
            {loading ? "Submitting" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivityModal;
